import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from '@bibliocommons/base-alerts';
import Checkbox from '@bibliocommons/base-checkbox';

import './ShelfPrivacyAlert.scss';

export default function ShelfPrivacyAlert({ setToPublic, handleChange }) {
  return (
    <div className="cp-ugc-shelf-privacy-alert">
      <Alert>
        <p><FormattedMessage id="ugc_shelf_privacy_alert" /></p>
        <Checkbox
          id="ugc-shelf-privacy-checkbox"
          checked={setToPublic}
          handleChange={handleChange}
          label={<FormattedMessage id="ugc_shelf_privacy_toggle" />} />
      </Alert>
    </div>
  );
}

ShelfPrivacyAlert.propTypes = {
  handleChange: PropTypes.func.isRequired,
  setToPublic: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/UGC/ShelfPrivacyAlert/ShelfPrivacyAlert.jsx